module.exports = __webpack_public_path__ + "img/pic_wangluoweilianjie@2x.9e26c68a.png";